import React from 'react';
import { VictoryLabel, VictoryClipContainer } from 'victory';
import { ChartTooltip } from '../../Timeline/ChartTooltip';
import { PersonsOffshoreTooltipContent } from './PersonsOffshoreTooltipContent';

export class LabelWithTooltip extends React.Component {
    static defaultEvents = ChartTooltip.defaultEvents;

    shouldComponentUpdate(nextProps) {
        return this.props.active !== nextProps.active;
    }

    render() {
        const { y, x, datum, chartWidth } = this.props;
        const dayInMilliseconds = 86400000;
        const timespan = datum.endDate - datum.beginDate;
        const width = Math.floor((timespan * (chartWidth - 110)) / dayInMilliseconds);
        const clipWidth = width > 10 ? width - 10 : 0;
        return (
            <g>
                <VictoryClipContainer
                    key="container"
                    clipWidth={clipWidth}
                    clipHeight={10}
                    translateX={x}
                    translateY={y - 5}
                    style={{ pointerEvents: 'none' }}>
                    <VictoryLabel {...this.props} y={y} />
                </VictoryClipContainer>

                <ChartTooltip key="tooltip" {...this.props} content={PersonsOffshoreTooltipContent} />
            </g>
        );
    }
}
